import { adModesTR } from './modes/adModes_tr';
import { adModesEN } from './modes/adModes_en';
import { adModesRU } from './modes/adModes_ru';

export const adModes = {
  tr: adModesTR,
  en: adModesEN,
  ru: adModesRU,
};
